import { useStore } from '@nanostores/solid'
import { createResource, Match, Switch } from 'solid-js'
import { productsReady } from '~/lib/message'
import { platform } from '~/lib/params'
import { selectPlanVariant, type SkuKey } from '~/lib/select-plan-variant'
import { m } from '~/paraglide/messages'
import { $chinaAndroidTrialEligibility, $selectedPlan } from '~/store'
import { PlanOption } from './plan-option'

const titleFor = (key: SkuKey): string => {
  switch (key) {
    case 'annualEarlyBird':
      return m.yearly_plan()
    case 'monthlyEarlyBird':
    case 'monthlyNoTrial':
      return m.monthly_plan()
  }
}

const planFor = (key: SkuKey): 'annual' | 'monthly' =>
  key === 'annualEarlyBird' ? 'annual' : 'monthly'

const selectedFor = (
  selectedPlan: 'annual' | 'monthly',
  key: SkuKey,
): boolean => planFor(key) === selectedPlan

export function PlanSelect() {
  const [products] = createResource(() => productsReady.promise)
  const chinaTrial = useStore($chinaAndroidTrialEligibility)
  const selectedPlan = useStore($selectedPlan)

  const variant = () =>
    selectPlanVariant({
      platform,
      products: products() ?? null,
      chinaAndroidTrialEligibility: chinaTrial(),
    })

  const handleSelect = (plan: 'annual' | 'monthly') => $selectedPlan.set(plan)

  return (
    <Switch>
      <Match when={variant().kind === 'loading'}>{null}</Match>
      <Match when={variant().kind === 'china-trial-cta'}>{null}</Match>
      <Match
        when={(() => {
          const v = variant()
          return v.kind === 'two-plans' ? v : null
        })()}
      >
        {(v) => (
          <div class="relative z-0 flex w-full flex-col items-center gap-3">
            <PlanOption
              title={titleFor(v().left)}
              earlyBirdProduct={products()![v().left]!}
              originalProduct={products()!.annualOriginal}
              selected={selectedFor(selectedPlan(), v().left)}
              plan={planFor(v().left)}
              selectPlan={handleSelect}
            />
            <PlanOption
              title={titleFor(v().right)}
              earlyBirdProduct={products()![v().right]!}
              originalProduct={products()!.monthlyOriginal}
              selected={selectedFor(selectedPlan(), v().right)}
              plan={planFor(v().right)}
              selectPlan={handleSelect}
            />
          </div>
        )}
      </Match>
    </Switch>
  )
}
